import { useLocalizedStringFormatter } from '@coursera/cds-common';

import { useTableContext } from '@core/table/features/TableContext';
import i18nMessages from '@core/table/i18n';
import VisuallyHidden from '@core/VisuallyHidden';

import getTableLabelCss, { classes } from './styles/getTableLabelCss';

export type Props = {
  // label can be typography H2 or H3 only
  label?: React.ReactNode;
  supportText?: React.ReactNode;
} & React.ComponentProps<'figcaption'>;

// Table Caption A11y Resource -> www.w3.org/WAI/tutorials/tables/caption-summary/
const TableLabel = (props: Props) => {
  const { id, pagination } = useTableContext();
  const { pageSize, page, totalRecords, hidePagination } = pagination;
  const { label, supportText, ...rest } = props;

  const stringFormatter = useLocalizedStringFormatter(i18nMessages);

  const paginationInfo = totalRecords
    ? stringFormatter.format('pagination_info', {
        pageSize,
        page,
        totalPages: Math.ceil(totalRecords / pageSize),
      })
    : '';

  return (
    <figcaption {...rest} css={getTableLabelCss}>
      {label && (
        <div className={classes.label} id={`${id}-label`}>
          {label}
        </div>
      )}
      {supportText && <span id={`${id}-support-text`}>{supportText}</span>}
      {!hidePagination && <VisuallyHidden>{paginationInfo}</VisuallyHidden>}
    </figcaption>
  );
};

export default TableLabel;
